import React, { Suspense, lazy } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import Preloader from './components/Preloader'
import { AlertProvider } from './context/AlertContext'
import AlertMessage from "./components/AlertMessage"
import ScrollToTop from './components/ScrollToTop'

const DroughtMap = lazy(() => import('./maps/DroughtMap'));
const EarthquakeMap = lazy(() => import('./maps/EarthquakeMap'));
const CycloneMap = lazy(() => import('./maps/CycloneMap'));
const FloodMap = lazy(() => import('./maps/FloodMap'));
const LightingMap = lazy(() => import('./maps/LightingMap'));
const EpidemicsMap = lazy(() => import('./maps/EpidemicsMap'));
const Contact = lazy(() => import('./pages/Contact'));
const Disclaimer = lazy(() => import('./pages/Disclaimer'));
const Acknowledgement = lazy(() => import('./pages/Acknowledgement'));

const EarthquakeDetails = lazy(() => import('./maps/EarthquakeDetails'));
const FloodDetails = lazy(() => import('./maps/FloodDetails'));
const EpidemicsDetails = lazy(() => import('./maps/EpidemicsDetails'));
const CycloneDetails = lazy(() => import('./maps/CycloneDetails'));
const LightingDetails = lazy(() => import('./maps/LightingDetails'));
const DroughtDetails = lazy(() => import('./maps/DroughtDetails'));

const QuizPage = lazy(() => import('./Quiz/QuizPage'));

const App = () => {
  return (
    <Router>
      <AlertProvider>
        <Navigation />
        <AlertMessage />
        <Suspense fallback={<Preloader />}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/drought' element={<DroughtMap />} />
            <Route path='/earthquake' element={<EarthquakeMap />} />
            <Route path='/cyclone' element={<CycloneMap />} />
            <Route path='/flood' element={<FloodMap />} />
            <Route path='/lighting' element={<LightingMap />} />
            <Route path='/epidemics' element={<EpidemicsMap />} />

            <Route path='/drought/drought-details' element={<DroughtDetails />} />
            <Route path='/lighting/lighting-details' element={<LightingDetails />} />
            <Route path='/cyclone/cyclone-details' element={<CycloneDetails />} />
            <Route path='/epidemics/epidemics-details' element={<EpidemicsDetails />} />
            <Route path='/flood/flood-details' element={<FloodDetails />} />
            <Route path='/earthquake/earthquake-details' element={<EarthquakeDetails />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/acknowledgement" element={<Acknowledgement />} />
            <Route path="/:Name/quiz" element={<QuizPage />} />
          </Routes>

        </Suspense>
        <ScrollToTop/>
      </AlertProvider>
      <Footer />
    </Router>

  )
}

export default App